import { Controller } from "@hotwired/stimulus"
import { csrfToken } from "../helpers"

export default class extends Controller {
  static values = { clickUrl: String, dismissalUrl: String }

  connect() {
    this.element.showPopover()
  }

  click() {
    this.record(this.clickUrlValue)
    this.element.hidePopover()
  }

  dismiss() {
    this.record(this.dismissalUrlValue)
  }

  record(url) {
    // Fire-and-forget telemetry: keepalive lets the POST survive popover/page
    // teardown, and the catch swallows network failures (a dropped dismissal
    // just means the announcement re-shows on the next load).
    fetch(url, {
      method: "POST",
      keepalive: true,
      headers: { "X-CSRF-Token": csrfToken() },
    }).catch(() => {})
  }
}
